import { Fragment } from "react"

import { Divider, Flex, Text } from "@/atoms"

import styles from "./TestImpactFormSection.module.scss"

import type { TFunction } from "@/hooks/useTranslation"

export const StatisticsTestImpact = (props: {
  summary: { changed: number; sampled: number }
  t: TFunction
}) => {
  const { summary, t } = props
  const items = ["sampled", "changed", "unchanged"]
  const { sampled = 0, changed = 0 } = summary || {}
  const unchanged = sampled - changed

  return (
    <Flex
      flex={1}
      align="center"
      justify="space-around"
      gap={8}
      className={styles.statistics}
    >
      {items.map((item, index) => (
        <Fragment key={item}>
          {index !== 0 && (
            <Divider vertical plain className={styles.statisticsDivider} />
          )}
          <Flex vertical gap={4} align="center">
            <Text strong className={styles.statisticsCount}>
              {item === "sampled" && sampled}
              {item === "changed" && changed}
              {item === "unchanged" && unchanged}
            </Text>
            <Text type="secondary" className="sm-text-ks">
              {t(`statistics.${item}`)}
            </Text>
          </Flex>
        </Fragment>
      ))}
    </Flex>
  )
}
